import preloader from "../../../assets/images/preloader.gif"
import React from "react"

const Preloader = () => (
    <div>
        <img alt='' src={preloader} width={100} height={100}/>
    </div>
)

export default Preloader